import React from "react";
import { Helmet } from "react-helmet";
import HeroSlider from "../components/HeroSlider";
import { useTranslation } from "react-i18next";

const Acasa = () => {
  const {t} = useTranslation();
  return (
    <>
      <div className="home-page">
        <Helmet>
          <title>
            Ticket | Min & Ying Legal Services Professional Corporation
          </title>
          
          <meta
            name="description"
            content="Ticket | Min & Ying Legal Services Professional Corporation"
          />
        </Helmet>
        <HeroSlider/>
        {/* <div className="container-fluid">
          <div className="row">
            <div className="hero-section">
              <div className="hero-overlay"></div>
              <div className="text-container d-flex flex-column justify-content-start align-items-start pt-6 slide">
                <div className="text-1 fs-2 pb-3 text-red-200">Min & Ying Legal Services Professional Corporation Professional Corporation222</div>
                <div className="text-2 fs-4">
                  Min & Ying Legal Services Professional Corporation Professional Corporation
                  <span className="fw-bold">
                    <br></br> Bucuresti{" "}
                  </span>
                </div>
                <div className="text-3 fst-italic fw-light">
                  "Nu este o adevărată justiție acolo unde nu există dreptate,
                  iar dreptatea nu poate fi găsită acolo unde nu există adevăr."
                  - <span>Lucius Annaeus Seneca.</span>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/*TE CONFRUNTI CU O PROBLEMA========= */}
        
        <section className="card py-5 px-3 border-0 container">
          <div className="row">
            <div className="col-lg-7">
              <div className="card-body">
                <h6 className="guide-text mb-4">{t('ticket.ticketServices')}</h6>
                <p className="fw-normal">
                  {t('ticket.ticketServicesIntro')}
                </p>
                <ul>
                  <li><a href="#ticket-service">{t('ticket.trafficTicket')}</a></li>
                  <li><a href="#company-service">{t('ticket.companyTicket')}</a></li>
                  <li><a href="#municipal-service">{t('ticket.municipalByLawTicket')}</a></li>
                </ul>
              </div>
            </div>

            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <div>
                <img
                  src="/assets/services/ticket.webp"
                  className="intro-img img-fluid d-block rounded-2"
                  alt=" a gavel, scales of justice, and law books"
                  style={{ maxHeight: "300px" }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* SERVICII========= */}
        <div>
          <div className="row">
            <div className="col">
              <div className="services-section" id="ticket-service">
                <div className="services-overlay "></div>

                <div className="services-content container p-5 mobile-padding">
                  {/* <h6 className="guide-text font-weight-bold">Traffic Ticket Service</h6> */}
                  <h3 className="lh-base text-center pb-3">
                    {t('ticket.trafficTicketServices.title')}
                  </h3>
                  <p className="mt-3 text-center">
                    {t('ticket.trafficTicketServices.trafficTicketServicesIntro')}
                  </p>
                  <p className="text-center pb-5">
                    {t('ticket.trafficTicketServices.trafficTicketServicesIntro2')}
                  </p>

                  <h6 className="guide-text mt-5 mb-3">{t('general.ourServices')}</h6>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('ticket.trafficTicketServices.service1')}</li>
                    <li>{t('ticket.trafficTicketServices.service2')}</li>
                    <li>{t('ticket.trafficTicketServices.service3')}</li>
                    <li>{t('ticket.trafficTicketServices.service4')}</li>
                    <li>{t('ticket.trafficTicketServices.service5')}</li>
                    <li>{t('ticket.trafficTicketServices.service6')}</li>
                    <li>{t('ticket.trafficTicketServices.service7')}</li>
                  </ul>
                  <p>
                    {t('ticket.trafficTicketServices.serviceSummary')}
                  </p>
                  <br/>
                  <h6 className="guide-text font-weight-bold mt-5 mb-3">{t('general.howCanWeHelp')}</h6>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('ticket.trafficTicketServices.help1')}</li>
                    <li>{t('ticket.trafficTicketServices.help2')}</li>
                    <li>{t('ticket.trafficTicketServices.help3')}</li>
                    <li>{t('ticket.trafficTicketServices.help4')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="row">
            <div className="col">
              <div id="company-service">
                <div className="container p-5 mobile-padding">
                  {/* <h6 className="guide-text font-weight-bold">Company Ticket Service</h6> */}
                  <h3 className="lh-base text-center pb-3">
                    {t('ticket.companyTicketServices.title')}
                  </h3>
                  <p className="mt-3 text-center pb-5">
                    {t('ticket.companyTicketServices.companyTicketServicesIntro')}
                  </p>
                  <h6 className="guide-text mt-5 mb-3">{t('general.ourServices')}</h6>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('ticket.companyTicketServices.service1')}</li>
                    <li>{t('ticket.companyTicketServices.service2')}</li>
                    <li>{t('ticket.companyTicketServices.service3')}</li>
                    <li>{t('ticket.companyTicketServices.service4')}</li>
                    <li>{t('ticket.companyTicketServices.service5')}</li>
                    <li>{t('ticket.companyTicketServices.service6')}</li>
                  </ul>
                  <p>
                    {t('ticket.companyTicketServices.serviceSummary')}
                  </p>
                  <br/>
                  <h6 className="guide-text font-weight-bold mt-5 mb-3">{t('general.howCanWeHelp')}</h6>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('ticket.companyTicketServices.help1')}</li>
                    <li>{t('ticket.companyTicketServices.help2')}</li>
                    <li>{t('ticket.companyTicketServices.help3')}</li>
                    <li>{t('ticket.companyTicketServices.help4')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div>
          <div className="row">
            <div className="col">
              <div className="services-section" id="municipal-service">
                <div className="services-overlay "></div>

                <div className="services-content container p-5 mobile-padding">
                  <h3 className="lh-base text-center pb-3">
                    {t('ticket.municipalTicketServices.title')}
                  </h3>
                  <p className="mt-3 text-center pb-5">
                    {t('ticket.municipalTicketServices.municipalTicketServicesIntro')}
                  </p>

                  <h6 className="guide-text mt-5 mb-3">{t('general.ourServices')}</h6>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('ticket.municipalTicketServices.service1')}</li>
                    <li>{t('ticket.municipalTicketServices.service2')}</li>
                    <li>{t('ticket.municipalTicketServices.service3')}</li>
                  </ul>
                  <p>
                    {t('ticket.municipalTicketServices.serviceSummary')}
                  </p>
                  <br/>
                  <h6 className="guide-text font-weight-bold mt-5 mb-3">{t('general.howCanWeHelp')}</h6>
                  <ul className="my-list" style={{paddingLeft: '0.5rem'}}>
                    <li>{t('ticket.municipalTicketServices.help1')}</li>
                    <li>{t('ticket.municipalTicketServices.help2')}</li>
                    <li>{t('ticket.municipalTicketServices.help3')}</li>
                    <li>{t('ticket.municipalTicketServices.help4')}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Acasa;
